import { render, staticRenderFns } from "./PsSwitch.vue?vue&type=template&id=ac6b42f0&scoped=true&"
import script from "./PsSwitch.vue?vue&type=script&lang=js&"
export * from "./PsSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac6b42f0",
  null
  
)

export default component.exports